// @ts-strict-ignore
import { IconName } from '@usealloy/component-library';
import { UserContext } from '~/dashboard/context';
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { libraryRoutes } from '~/helpers/api-new/modules/library/libraryRoutes';
import { routes } from '~/helpers/routes';
import { StyledIcon } from './SidebarStyle';
import { redirectToRuleLibrary } from './useRuleLibrarySession';

export const AdminSidebarLinks = () => {
  const {
    agent: { isEmployee },
    featureFlags,
  } = useContext(UserContext);
  const location = useLocation();
  const getNavLinkClass = path => (location.pathname.match(new RegExp(`^${path}`)) ? 'active' : '');
  const {
    customers, globalServices, notifications, employees, ai,
  } = routes.v3.dashboard.admin;

  const shouldShowLibrary = featureFlags?.ruleLibraryPhase >= 1;

  const handleLibraryClick = e => {
    e.preventDefault();
    redirectToRuleLibrary(libraryRoutes.globalRepository.view);
  };

  return (
    <>
      <li className={`${getNavLinkClass(customers.list)} flex center`}>
        <span className="active-bar" />
        <a href={`${window.location.origin}${customers.list}`} className="flex">
          <StyledIcon icon={IconName.Customers} />
          <span className="text fs-unmask">Customers</span>
        </a>
      </li>
      {isEmployee && (
        <>
          <li className={`${getNavLinkClass(globalServices.list)} flex center`}>
            <span className="active-bar" />
            <a
              href={`${window.location.origin}${globalServices.list}`}
              className="flex"
            >
              <StyledIcon icon={IconName.Service} />
              <span className="text fs-unmask">Services</span>
            </a>
          </li>

          <li className={`${getNavLinkClass(notifications.list)} flex center`}>
            <span className="active-bar" />
            <a
              href={`${window.location.origin}${notifications.list}`}
              className="flex"
            >
              <StyledIcon icon={IconName.Email} />
              <span className="text fs-unmask">Notifications</span>
            </a>
          </li>

          <li className={`${getNavLinkClass(employees.list)} flex center`}>
            <span className="active-bar" />
            <a
              href={`${window.location.origin}${employees.list}`}
              className="flex"
            >
              <StyledIcon icon={IconName.Employees} />
              <span className="text fs-unmask">Employees</span>
            </a>
          </li>

          {shouldShowLibrary && (
            <li
              className={`${getNavLinkClass(libraryRoutes.globalRepository.view)} flex center`}
            >
              <span className="active-bar" />
              <a
                href={`${window.location.origin}${libraryRoutes.globalRepository.view}`}
                className="flex"
                onClick={handleLibraryClick}
              >
                <StyledIcon icon={IconName.Library} />
                <span className="text fs-unmask">Policy Library</span>
              </a>
            </li>
          )}

          <li className={`${getNavLinkClass(ai.view)} flex center`}>
            <span className="active-bar" />
            <a href={`${window.location.origin}${ai.view}`} className="flex">
              <StyledIcon icon={IconName.Sparkles} />
              <span className="text fs-unmask">AI</span>
            </a>
          </li>
        </>
      )}
    </>
  );
};
